import { render, staticRenderFns } from "./CustomAuthBtn.vue?vue&type=template&id=2fa6d658"
import script from "./CustomAuthBtn.vue?vue&type=script&lang=js"
export * from "./CustomAuthBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports